module.exports = __webpack_public_path__ + "img/04.611ea27c.png";